import React, { useContext, useMemo, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

// CONTEXT
import { AuthContext } from 'context/AuthContext';

// HOOKS
import useUserData from 'hooks/useUserData';

// COMPONENTS
import Loader from 'components/loaderComponent';
import AuthenticationForm from 'components/authenticationFormComponent';
import Header from 'components/headerComponent';
import Grid from 'components/gridComponent';
import InfoBubble from 'components/infoBubbleComponent';

// UTILS
import { MapPreferencesToTiles } from 'utils/mapPreferencesToTiles';
import fakeTiles from 'utils/fakeTiles';

function Home() {
    const { authenticated, email, isInternal, isExternal, isAdmin, loading: authLoading } = useContext(AuthContext);
    const { userADInfo, userBDDInfo, preferences, loading: userDataLoading, refreshPreferences } = useUserData(email, isInternal, isExternal, isAdmin);
    const [gridReady, setGridReady] = useState(false);

    const loading = authLoading || userDataLoading || !gridReady;

    // Rafraîchir les préférences à chaque arrivée sur la home : les données user
    // sont désormais mutualisées (fetch unique), donc revenir d'une édition ou du
    // panel admin ne relance plus automatiquement le fetch. On le force ici.
    useEffect(() => {
        refreshPreferences();
    }, [refreshPreferences]);

    const tiles = useMemo(() => {
        if (authenticated && preferences) {
            return MapPreferencesToTiles(preferences);
        }
        return fakeTiles;
    }, [authenticated, preferences]);

    // Effet pour gérer le chargement de la grille
    useEffect(() => {
        if (tiles && tiles.length > 0) {
            // Réduire le délai pour un chargement plus rapide
            const timer = setTimeout(() => {
                setGridReady(true);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [tiles]);

    return (
        <>
        <Helmet>
            <title>HUB ・ Altitude Infra</title>
            <meta name="description" content="Bienvenue sur le HUB d'Altitude Infra, votre portail d'accès aux services internes." />
        </Helmet>
        <div className="liquid-bg bg-blanc dark:bg-noir text-blanc dark:text-noir">
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Header user={userBDDInfo && userADInfo ? { userBDDInfo, userADInfo } : null} />
                    <div className="flex-grow flex justify-center items-center px-4 py-1 relative">
                        <div className={`relative w-full h-full flex justify-center items-center ${!authenticated ? 'blur-sm' : ''}`}>
                            <Grid 
                                user={userBDDInfo && userADInfo ? { userBDDInfo, userADInfo } : null} 
                                tiles={tiles} 
                                onGridReady={() => setGridReady(true)}
                            />
                        </div>
                        {!authenticated && (
                            <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center max-h-[80vh] max-w-md mx-auto">
                                <AuthenticationForm />
                            </div>
                        )}
                    </div>
                    <InfoBubble />
                </>
            )}
        </div>
        </>
    );
}

export default Home;